import { APP_NONCE } from '@/config';
import referralApiService from '@/request/referral/referral.api.service';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import dayjs from 'dayjs';

export const useAuth = (handler: () => void) => {
  const { isConnected, walletAddress, signMessage, chain } = useBoomWallet();

  const account = walletAddress?.toLocaleLowerCase();

  const checkState = async () => {
    try {
      if (account && isConnected) {
        if (!localStorage.getItem(account)) {
          privyAuthLogin();
        } else {
          handler();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const privyAuthLogin = async () => {
    try {
      if (walletAddress && isConnected && account) {
        const deadline = dayjs().add(1, 'day').unix();
        const messageBytes = `${APP_NONCE} ${walletAddress}.[${deadline}]`;
        const signature = (await signMessage(messageBytes)) as string;

        const res = await referralApiService.emailLogin({
          account: walletAddress!,
          deadline,
          signature,
          chain_symbol: chain,
        });

        if (res.jwt_token) {
          localStorage.setItem(account, res.jwt_token);
          checkState();
        }
      }
    } catch (error) {
      console.error('privy 登录报错', error);
      throw error;
    }
  };

  return { checkState, privyAuthLogin };
};
